const INTERNAL_REQUEST_EVENTS = Object.freeze({
  NOTIFICATION: 'internalRequestNotification',
});

export default INTERNAL_REQUEST_EVENTS;
